module.exports = __webpack_public_path__ + "static/media/boxes-biweekly.82b104ee.png";